var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.639,
    height: 7.227,
    viewBox: "0 0 12.639 7.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M12.51,16.295l4.779-4.783a.9.9,0,0,1,1.276,0,.911.911,0,0,1,0,1.279L13.149,18.21a.9.9,0,0,1-1.246.026L6.451,12.8a.9.9,0,0,1,1.276-1.279Z",
    transform: "translate(-6.188 -11.247)",
    fill: "#3dc5d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.8a57c7782fac89a20864ebf4d789bb89.svg";
export { ForwardRef as ReactComponent };